module.exports = __webpack_public_path__ + "static/img/baihe.dd2488d2.png";